import { Dialog } from 'primereact/dialog';
import { FC, useEffect, useState } from 'react';
import { ReportSubtype } from '../../../../models/Report';
import { useLazyLoadQuery } from 'react-relay';
import { ReportHubViewExamplePresignedUrlQuery } from '../../../../graphQLOperations/__generated__/ReportHubViewExamplePresignedUrlQuery.graphql';
import { getViewExamplePresignedUrl } from '../../../../graphQLOperations/ReportHub';
import { BigPlayButton, Player } from 'video-react';
interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  selectedReportSubtype: ReportSubtype | null;
}

const ReportHubViewExampleReportModal: FC<Props> = ({ visible, setVisible, selectedReportSubtype }) => {
  const [viewExampleMedia, setViewExampleMedia] = useState<string | null>(null);

  const { presignedURLsForReportExamples } = useLazyLoadQuery<ReportHubViewExamplePresignedUrlQuery>(
    getViewExamplePresignedUrl,
    { filter: { reportType: 'ALL' } },
    { fetchPolicy: 'store-and-network' },
  );

  useEffect(() => {
    if (selectedReportSubtype === ReportSubtype.PROGRESS_DETAILED_SKILL_REPORT) {
      setViewExampleMedia(presignedURLsForReportExamples.detailedSkillReportExampleUrl as string);
    }
    if (selectedReportSubtype === ReportSubtype.DIAGNOSTIC_SUMMARY) {
      setViewExampleMedia(presignedURLsForReportExamples.diagnosticSummaryReportExampleUrl as string);
    }
    if (selectedReportSubtype === ReportSubtype.DIAGNOSTIC_STUDENTS_UNFINISHED_DIAGNOSTIC) {
      setViewExampleMedia(presignedURLsForReportExamples.unfinishedDiagnosticsReportExampleUrl as string);
    }
    if (selectedReportSubtype === ReportSubtype.PROGRESS_SKILL_ASSESSMENT_HISTORY) {
      setViewExampleMedia(presignedURLsForReportExamples.skillAssessmentHistoryReportExampleUrl as string);
    }
  }, [presignedURLsForReportExamples]);

  return (
    presignedURLsForReportExamples && (
      <Dialog
        header={<h3 className="md:text-2xl text-lg">Report example</h3>}
        visible={visible}
        style={{ width: selectedReportSubtype === ReportSubtype.PROGRESS_DETAILED_SKILL_REPORT ? '60vw' : '40vw' }}
        breakpoints={{ '960px': '75vw', '576px': '100vw' }}
        onHide={() => setVisible(false)}
      >
        {selectedReportSubtype === ReportSubtype.PROGRESS_DETAILED_SKILL_REPORT ? (
          <>
            <Player
              onPlay={() => {}}
              onEnded={() => {}}
              onLoadStart={() => {}}
              onPause={() => {}}
              videoId=""
              crossOrigin="anonymous"
            >
              <BigPlayButton position="center" />
              <source src={viewExampleMedia || ''} />
            </Player>
            {/* <p className="text-lg" style={{ fontFamily: 'Poppins' }}>
              For more detailed information about this report, you can visit{' '}
              <a className="text-lg" style={{ fontFamily: 'Poppins' }}>
                this link.
              </a>
            </p> */}
          </>
        ) : (
          <img src={`${viewExampleMedia}`} alt="Report example" style={{ width: '100%' }} />
        )}
      </Dialog>
    )
  );
};

export default ReportHubViewExampleReportModal;
